export default __webpack_public_path__ + "static/media/IMG_9984.c65bf54b.jpg";